module.exports = __webpack_public_path__ + "img/filterIcon.aa22709d.svg";